export const CoreOntology = {
    
    "namespace": "core",
    "description": "Core / upper ontology for all things 4DMapper apps and services",
    "schema": "https://ontologies.4dmapper.com/xso",
    
    "core:isA": {
        "description": "Core typeification moniker; all things isA another thing",
        "cardinality": "*?"
    },
    "core:hasA": {
        "description": "Core property moniker; a lot of things hasA another thing",
        "cardinality": "*?"
    },
    "core:existanceIs": {
        "description": "Core existential types",
        "cardinality": "1?",

        "core:real": {
            "description": "Reality; the domain that natural sciences study"
        },
        "core:conceptual": {
            "description": "Conceptuality; the human idea of reality"
        },
        "core:represential": {
            "description": "Representiality; artefacts describing reality so humans can conceptualise"
        }
    },

    "core:parent": {
        "label": "Parent",
        "description": "A Parent thing of other thing(s)"
    },
    "core:child": {
        "label": "Child",
        "description": "A child thing of a parent thing"
    },
    "core:also-all-children": {
        "description": "A pseudo-type; it's an instruction to the core type parser to give all children of this type the same type"
    },

    "core:section": {
        "label": "Section",
        "description": "is a section of a larger thing"
    },

    "core:organisation": {
        "label": "Organisation",
        "description": "An organisation of people and processes",
        "core:company": {
            "label": "Company",
            "description": "A commercial organisation"
        },
        "core:partner": {
            "label": "Partner",
            "description": "A partner organisation to another organisation for some benefitional gain"
        }
    },

    "core:person": {
        "label": "Person",
        "description": "A person",
        "core:employee": {
            "label": "Employee",
            "description": "An employee works for an organisation"
        },
        "core:consultant": {
            "label": "Consultant",
            "description": "A consultant is an independant person who does work on behalf of or for an organisation"
        },
        "core:independant": {
            "label": "Independant",
            "description": "An independant person; researcher, hobbyist, interested, or otherwise not invested in a specific organisation"
        }
    }

}

export const GisOntology = {
    "namespace": "gis",
    "description": "GeoSpatial domain ontology",
    "schema": "https://ontologies.4dmapper.com/xso",
    
    "namespaces": {
        "core": "https://ontologies.4dmapper.com/core"
    },
    "shorthand": "core",

    "gis:science": {
        "gis:planetary-science": {
            "isA": "core:domain",
            "gis:atmosphere": {
                "isA": "core:section"
            },
            "gis:biosphere": {
                "isA": "core:section"
            },
            "gis:hydrosphere": {
                "isA": "core:section"
            },
            "gis:lithosphere": {
                "isA": "core:section"
            }
        }
    },

    "gis:universe": {
        "label": "Universe",
        "cardinality": "1",
        "existanceIs": "core:real",
        "gis:galaxy": {
            "label": "Galaxy",
            "cardinality": "*",
            "gis:solar-system": {
                "label": "Solar system",
                "cardinality": "*",
                "gis:star": {
                    "label": "Star",
                    "cardinality": "*",
                    "gis:sol": {
                        "label": "The sun",
                        "isA": "gis:star",
                        "existanceIs": "core:real"
                    }
                },
                "gis:planet": {
                    "label": "A planet",
                    "cardinality": "*?",
                    "gis:earth": {
                        "label": "Earth",
                        "description": "Our planet Earth",
                        "isA": "gis:planet",
                        "existanceIs": "core:real",
                        "hasA": "gis:atmosphere gis:biosphere gis:hydrosphere gis:lithosphere"
                    },
                    "gis:moon": {
                        "label": "A moon",
                        "cardinality": "*?",
                        "gis:luna": {
                            "label": "The moon",
                            "description": "Our Cheesy Moon",
                            "isA": "gis:moon",
                            "existanceIs": "core:real"
                        }
                    }
                    
                }
            }
        }
    },

    "gis:data": {
        "gis:datatype": {
            "gis:datatype-raster": {},
            "gis:datatype-vector": {},
            "gis:datatype-tileset": {}
        }
    }

}

export const SystemOntology = {
    "namespace": "sys",
    "description": "System and Application ontology",
    "schema": "https://ontologies.4dmapper.com/xso",
    
    "namespaces": {
        "core": "https://ontologies.4dmapper.com/core",
        "gis": "https://ontologies.4dmapper.com/gis"
    },
    "shorthand": "core",


    "sys:computer": {
        "sys:input": {
            "sys:screen": {},
            "sys:mouse": {},
            "sys:keyboard": {}
        },
        "sys:data": {
            "sys:folder": {
                "sys:file": {}
            }
        },
        "sys:processing": {
            "sys:state": {
                "sys:expanded-event": { "description": "An expanded event will automatically also get sub-events; _init, _start, _update, _end" },
                "sys:event": {
                    "isA": "sys:expanded-event core:also-all-children",
                    "description": "Events drive the flow of the application with different events of different states",
                    "sys:event-linear": { "description": "The system fires these off one after the other, like a trail of breadcrumbs through a forest..." },
                    "sys:event-reaction": { "description": "The system reacts to certain states" },
                    "sys:event-interaction": { "description": "The system reacts to user interaction" },
                    "sys:event-action": { "description": "The system reacts to processes being started or stopped" },
                    "sys:event-items": {
                        "description": "The item events is important; all things that come and go in our system will fire these; User, Account, Project, Scene, Transform, Photo ...",
                        "sys:event-item-core": {},
                        "sys:event-item-ui": {
                            "sys:event-item-ui-panel": {},
                            "sys:event-item-ui-map": {}
                        },
                        "sys:event-item-data": {
                            "sys:event-item-data-transform": {
                                "sys:event-item-data-raster": {},
                                "sys:event-item-data-vector": {},
                                "sys:event-item-data-tileset": {}
                            },
                            "sys:event-item-data-dataset": {},
                            "sys:event-item-data-annotation": {}
                            
                        }
                    }
                }
            },
            "sys:pipe": {
                "description": "Pipes are how plugins send packets of data between them, often to form chains of converting or transfering data to and fro",
                "sys:pipe-input": {},
                "sys:pipe-output": {}
            },
            "sys:storage": {}
        },
        "sys:code": {
            "sys:plugin": {
                "description": "Plugins come in all colors and sizes...",
                "sys:module": { "description": "Modules are larger libraries and more complex code" },
                "sys:service": { "description": "Services are shared plugins for communicating and handling integration" },
                "sys:manager": { "description": "Managers manage groups of smaller items, from controllers and down" },
                "sys:controller": { "description": "Controllers deal with groups of smaller items" },
                "sys:component": { "description": "A Component is usually associated with a visual Widget and some controller code, with a minimum API" },
                "sys:plug": { 
                    "description": "A Plug is a plugin that controls some aspect of a core 4DM object (labels on a Transform, Colors of an Entity, Label on a Project, Map pin icon of a Photo, etc.)",
                    "sys:plug-account": { "description": "A Plug on an Account object" },
                    "sys:plug-user": { "description": "A Plug on a User object" },
                    "sys:plug-project": { "description": "A Plug on a Project object" },
                    "sys:plug-scene": { "description": "A Plug on a Scene object" },
                    "sys:plug-map": { "description": "A Plug on a Map (viewer) object" },
                    "sys:plug-camera": { "description": "A Plug on a Camera object" },
                    "sys:plug-transform": { "description": "A Plug on a Transform object" },
                    "sys:plug-annotation": { "description": "A Plug on a Annotation object" },
                    "sys:plug-photo": { "description": "A Plug on a Photo object" }
                }
            }
        },
        "sys:output": {
            "sys:screen": {},
            "sys:sound": {}
        }
    },

    "sys:test-plugin": {
        "isA": "sys:plugin",
        "hasA": "sys:pipe-input sys:pipe-output"
    },

    "sys:application": {

        "sys:domain": {
            "description": "Our System Domain is the conceptual area of knowledge about our system. This is where we conceptually dream up how applications are made!"
        },

        "sys:bootstrap": {
            "description": "Here's where we go to bootstrap / startup / setup / initiate / hack together our software application",
            
            "sys:event-stack": {
                "isA": "sys:event core:also-all-children",
                "description": "The event stack is what fires up when you start the whole application, and allow plugins and code to attach event listeners to what they find interesting. From this type and all the way down are turned into events that fire according to their event types",

                "sys:event-configuration": {},

                "sys:event-framework": {
                    "sys:event-framework-modules": {
                        "description": "Modules are larger system blocks needed, like bootloaders, core libraries and technologies, database connectors / ORMs, etc.",
                        "sys:event-framework-services": {
                            "description": "Services are code and libraries of reusable and frequent nature, like APIs into functionality, db queries, data persistance, conversions, etc.",
                            "sys:event-framework-controllers": {
                                "description": "Controllers manages communication and data between services and components",
                                "sys:event-framework-components": {
                                    "description": "Components are collections of code and possibly templates for managing smaller and contained jobs, like interactions, inputs, visualisation, etc.",
                                    "sys:event-framework-plugs": {
                                        "description": "Plugs are tiny pieces of code that plug into various places (this ontology, events, objects in the code, and so on) that do specific functionality. They could be anything. (These used to be called 'plugins')"
                                    }
                                }
                            }
                            
                        }
                    }
                },
                
                "sys:event-application": {
                    "sys:event-application-configure": {},
                    "sys:event-application-start": {},
                    "sys:event-application-divert": {},
                    "sys:event-application-end": {}
                }
            }
        },
        "sys:interaction": {}
    }
}

export const PluginsOntology = {
    "namespace": "plugins",
    "description": "plugins ontology",
    "schema": "https://ontologies.4dmapper.com/xso",
    
    "namespaces": {
        "core": "https://ontologies.4dmapper.com/core",
        "gis": "https://ontologies.4dmapper.com/gis",
        "sys": "https://ontologies.4dmapper.com/system"
    },
    "shorthand": "core",

    "plugins:controllers":{
        "isA": "sys:plugin core:only-all-children",
        "plugins:scene-light-controller": {}
    },

    "plugins:visual": {
        "isA": "sys:plugin core:only-all-children",
        "plugins:ding": {},
        "plugins:dong": {},
        "plugins:foo": {},
        "plugins:bar": {}
    }
    

}